import { render, staticRenderFns } from "./WksDeliveryList.vue?vue&type=template&id=2f15f022&scoped=true&"
import script from "./WksDeliveryList.vue?vue&type=script&lang=js&"
export * from "./WksDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15f022",
  null
  
)

export default component.exports